import type {
    GetCommerceEnrollmentRequest,
    GetCommerceEnrollmentResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";
export const getCommerceEnrollmentOperation: CommerceOperation<
    GetCommerceEnrollmentRequest,
    GetCommerceEnrollmentResponse
> = Object.freeze({ name: "commerce.enrollment.get" });
